import { createFileRoute } from '@tanstack/react-router'

import { AcceptInviteScreen } from '@/features/invites/accept-invite'
import { inviteSearchSchema } from '@/features/invites/invite-search'

/**
 * An invite's link (platform console, Invites): open to anyone, signed in or not, since the link
 * is the credential. The screen decides what the person does with it.
 */
export const Route = createFileRoute('/invite')({
  validateSearch: (search) => inviteSearchSchema.parse(search),
  component: AcceptInviteScreen,
})
